import { render, staticRenderFns } from "./publicSentimentDetail.vue?vue&type=template&id=5fb6e20d"
import script from "./publicSentimentDetail.vue?vue&type=script&lang=js"
export * from "./publicSentimentDetail.vue?vue&type=script&lang=js"
import style0 from "./publicSentimentDetail.vue?vue&type=style&index=0&id=5fb6e20d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports